export default __webpack_public_path__ + "static/media/github.d40637b0.svg";